// src/components/page-content-v4/modules/SEOFormSection.tsx
import React from 'react';
import FieldRenderer from '@/components/page-content-v4/modules/FieldRenderer';
import { PageData, Field } from '@/components/page-content-v4/types';

interface SEOFormSectionProps {
  page: PageData;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const SEOFormSection: React.FC<SEOFormSectionProps> = ({ page, onInputChange }) => {
  const seoFields: Field[] = [
    {
      id: 'seo-meta-title',
      type: 'text',
      label: 'Meta Title',
      key: 'metaTitle',
      settings: {},
      parentId: null,
      isRequired: true,
    },
    {
      id: 'seo-meta-description',
      type: 'textarea',
      label: 'Meta Description',
      key: 'metaDescription',
      settings: {},
      parentId: null,
      isRequired: true,
    },
    {
      id: 'seo-canonical-url',
      type: 'url',
      label: 'Canonical URL',
      key: 'canonicalUrl',
      settings: {},
      parentId: null,
      isRequired: false,
    },
    {
      id: 'seo-keywords',
      type: 'multiselect',
      label: 'Keywords',
      key: 'keywords',
      settings: {},
      parentId: null,
      isRequired: false,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-gray-900">SEO Optimization</h3>
          <p className="text-sm text-gray-500 mt-1">
            Optimize your page for search engines and social media sharing
          </p>
        </div>
        <div className="space-y-6">
          {seoFields.map((field) => (
            <FieldRenderer
              key={field.id}
              field={field}
              value={page.seo[field.key as keyof typeof page.seo]}
              onChange={(key, value) =>
                onInputChange({
                  target: { name: `seo.${key}`, value },
                } as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)
              }
            />
          ))}
        </div>
      </div>

      {/* SEO Preview */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h4 className="text-sm font-semibold text-gray-900 mb-4">Search Preview</h4>
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
          <div className="text-blue-600 text-lg font-medium line-clamp-1">
            {page.seo.metaTitle || page.title || 'Page Title'}
          </div>
          <div className="text-green-700 text-sm mt-1">
            {page.seo.canonicalUrl || 'https://example.com/page-url'}
          </div>
          <div className="text-gray-600 text-sm mt-2 line-clamp-2">
            {page.seo.metaDescription || 'Add a meta description to improve your search engine visibility...'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SEOFormSection;
